import { Button, Form, Input, message } from 'antd'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
    getCurrentProjectId,
    isValidArray,
    isValidObject,
} from '../testCases/forms/helper'
import { createTestRun } from '../../../redux/testRun/testRun.service'
import { testCaseState } from '../../../redux/testCases/testCaseList.slice'

const { TextArea } = Input

function TestRunForm(props) {
    const { selectedRowKeys = [], setOpen = () => {} } = props
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const { filter, searchValue } = useSelector(testCaseState)

    // const {
    //     testCaseDetailLoading = false,
    //     testCaseDetail: testCaseDetailData = {},
    // } = useSelector(testCaseState)

    const [submitType, setSubmitType] = useState('close')
    const [isCreateTag, setCreateTag] = useState(false)
    const [saveLoading, setSaveLoading] = useState(false)

    const currentProjectId = getCurrentProjectId()

    const handleSubmit = async (values) => {
        setSaveLoading(true)
        console.log('Log ==>filter', filter)
        const finalEpics = isValidArray(filter?.epic)
            ? filter?.epic?.map((item) => item?.value)
            : []
        const finalTags = isValidArray(filter?.tags)
            ? filter?.tags?.map((item) => item?.value)
            : []

        const payload = {
            filter: {
                epic: finalEpics,
                sprint: filter?.sprint?.value || '',
                tags: finalTags,
                project: currentProjectId,
            },
            search: {
                title: searchValue,
                testId: searchValue,
            },
            name: values?.title || '',
            testcaseIds: selectedRowKeys,
        }
        console.log('Log ==>values', values)
        const resp = await createTestRun(payload)
        if (resp?.data?.success) {
            message.success(
                resp?.data?.message || 'Test Run created successfully.'
            )
            setOpen(false)
        } else {
            message.error(resp?.data?.message || 'Something went wrong!')
        }
        setSaveLoading(false)
        console.log('Log ==>resp', resp)
    }

    return (
        <div
            style={{
                maxWidth: 700,
                margin: '0 auto',
                paddingLeft: '20px',
                paddingRight: '20px',
                paddingTop: '20px',
                background: '#fff',
                borderRadius: '8px',
            }}
        >
            <Form
                form={form}
                layout="vertical"
                // labelCol={{ span: 6 }}
                // wrapperCol={{ span: 18 }}
                labelAlign="left"
                onFinish={handleSubmit}
                initialValues={{
                    name: '',
                }}
            >
                {/* Title */}
                <Form.Item
                    label="Title"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: 'Title is required',
                        },
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <Input placeholder="Enter title" />
                </Form.Item>

                <div>
                    <p>{selectedRowKeys?.length} test cases are selected.</p>
                </div>

                {/* Sticky actions */}

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'end',
                        width: '100%',
                        gap: '10px',
                        marginTop: 25,
                    }}
                >
                    <Button
                        type="default"
                        htmlType="submit"
                        loading={saveLoading}
                        onClick={() => setSubmitType('close')}
                    >
                        Create
                    </Button>

                    <Button
                        type="default"
                        htmlType="button"
                        onClick={() => {
                            setOpen(false)
                        }}
                    >
                        Cancel
                    </Button>
                </div>
            </Form>
        </div>
    )
}

export default TestRunForm
